import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cw-slug-input',
  templateUrl: './slug-input.component.html',
  styleUrls: ['./slug-input.component.scss']
})
export class SlugInputComponent implements OnInit {
  @Input() thingToSlug: string;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/slug-input/slug-input.component.ts